import {IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {CustomerFilter} from "../../customers/model/CustomerFilter";

export class CustomerFilterParametersService {

    static instance = ['$http', CustomerFilterParametersService];
    private $http: IHttpService;

    constructor($http: IHttpService) {
        this.$http = $http;
    }

    findFilteredCustomersAmountOptions = (filter: CustomerFilter): ng.IHttpPromise<RangeOptionsDto> => {
        return this.$http({
                method: 'POST',
                url: getAbsoluteUrl('api/customer/filtered/loan/options'),
                data: filter
            }
        )
    }

    findStatesOptions = (): ng.IHttpPromise<string[]> => {
        return this.$http({
                method: 'GET',
                url: getAbsoluteUrl('address/states'),
            }
        )
    }

}
